// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 895) return "895/895.836adb7ef37d0fbe628f.min.css";
	if (chunkId === 141) return "history/history.8c5b220bf6f482881a90.min.css";
	// return url for filenames based on template
	return undefined;
};